"use strict";

exports.__esModule = true;
exports.VideoClicks = void 0;
var _StringUtils = require("../Utils/StringUtils");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var VideoClicks = /*#__PURE__*/function () {
  function VideoClicks(clickThroughUrl, clickTrackingUrls, customClicks) {
    /** @private */
    this.clickThroughUrl = clickThroughUrl ? clickThroughUrl : "";
    /** @private */
    this.clickTrackingUrls = clickTrackingUrls ? clickTrackingUrls : [];
    /** @private */
    this.customClicks = customClicks ? customClicks : [];
  }
  var _proto = VideoClicks.prototype;
  _proto.getClickThroughUrl = function getClickThroughUrl() {
    return this.clickThroughUrl;
  };
  _proto.getClickTrackingUrls = function getClickTrackingUrls() {
    return this.clickTrackingUrls;
  };
  _proto.getCustomClicks = function getCustomClicks() {
    return this.customClicks;
  };
  _proto.toString = function toString() {
    var s = "";
    if (!(0, _StringUtils.isNullOrEmpty)(this.clickThroughUrl)) {
      s += "\n* Click-through Url: ";
      s += this.clickThroughUrl;
    }
    if (this.clickTrackingUrls.length > 0) {
      for (var _iterator = _createForOfIteratorHelperLoose(this.clickTrackingUrls), _step; !(_step = _iterator()).done;) {
        var ctu = _step.value;
        s += "\n* Click tracking Url: ";
        s += ctu;
      }
    }
    if (this.customClicks.length > 0) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(this.customClicks), _step2; !(_step2 = _iterator2()).done;) {
        var cc = _step2.value;
        s += "\n* Custom click Url: ";
        s += cc;
      }
    }
    return s;
  };
  return VideoClicks;
}();
exports.VideoClicks = VideoClicks;